/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from 'src/app/store/app.reducer';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
    selector: 'app-appdownload',
    templateUrl: './appdownload.component.html',
})
export class AppDownloadComponent implements OnInit {

    SetupAndroid = 'https://play.google.com/store/apps/details?id=com.came.crpconnectapp';
    SetupApple = 'https://apps.apple.com/it/app/connect-setup/id1230364700';
    AutomationAndroid = 'https://play.google.com/store/apps/details?id=com.came.cameconnectapp';
    AutomationApple = 'https://apps.apple.com/it/app/came-automation/id1098115880';
    AutomationBTAndroid = 'https://play.google.com/store/apps/details?id=com.came.camebleapp';
    AutomationBTApple = 'https://apps.apple.com/it/app/automationbt/id1108961178';
    ThermoAndroid = 'https://play.google.com/store/apps/details?id=com.came.thermo&hl=it&gl=US';
    ThermoApple = 'https://apps.apple.com/it/app/thermo/id1116905424';
    ThermoGSMAndroid = 'https://play.google.com/store/apps/details?id=com.came.thermoGSM&hl=it&gl=US';
    ThermoGSMApple = 'https://apps.apple.com/it/app/thermogsm/id551584955';
    ThermoWIFIAndroid = 'https://play.google.com/store/apps/details?id=com.came.thermosg';
    ThermoWIFIApple = 'https://apps.apple.com/app/thermo-wifi/id1584633350';
    CameAccessAndroid = 'https://play.google.com/store/apps/details?id=com.came.myaccess';
    CameAccessApple = 'https://apps.apple.com/app/id6449211605';
    SetupProAndroid = 'https://play.google.com/store/apps/details?id=com.came.installer';
    SetupProApple = 'https://apps.apple.com/us/app/setup-pro/id6474442913';


    UpdateSetupProAndroidIt = 'https://www.came.com/global/app-pages/app-play-store_it.php';
    UpdateSetupProAndroidEn = 'https://www.came.com/global/app-pages/app-play-store_en.php';
    UpdateSetupProAndroidFr = 'https://www.came.com/global/app-pages/app-play-store_fr.php';
    UpdateSetupProAndroidDe = 'https://www.came.com/global/app-pages/app-play-store_de.php';
    UpdateSetupProAndroidNl = 'https://www.came.com/global/app-pages/app-play-store_nl.php';
    UpdateSetupProAndroidRu = 'https://www.came.com/global/app-pages/app-play-store_ru.php';


    appId: string;
    lang: string;
    browserDevice = 'PC';
    link = '';

    constructor(
        private route: ActivatedRoute,
        private translate: TranslateService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.appId = this.route.snapshot.queryParamMap.get('id');
        this.lang = this.route.snapshot.queryParamMap.get('language');
        if (navigator.userAgent.toLowerCase().includes('iphone') || navigator.userAgent.toLowerCase().includes('ipad')) {
            this.browserDevice = 'IOS';
        } else if (navigator.userAgent.toLowerCase().includes('android') || navigator.userAgent.toLowerCase().includes('linux')) {
            this.browserDevice = 'ANDROID';
        }
        switch (this.browserDevice) {
            case 'IOS': {
                this.redirectApple();
                break;
            }
            case 'ANDROID': {
                this.redirectAndroid();
                break;
            }
            default: {
                this.link = navigator.userAgent + '--Err--' + this.browserDevice;
                break;
            }
        }
    }

    redirectAndroid(): void {
        switch (this.appId) {
            case 'Setup': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'Setup' } }));
                window.location.href = this.SetupAndroid;
                this.link = this.SetupAndroid;
                break;
            }
            case 'Automation': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'Automation' } }));
                window.location.href = this.AutomationAndroid;
                this.link = this.AutomationAndroid;
                break;
            }
            case 'AutomationBT': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'AutomationBT' } }));
                window.location.href = this.AutomationBTAndroid;
                this.link = this.AutomationBTAndroid;
                break;
            }
            case 'Thermo': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'Thermo' } }));
                window.location.href = this.ThermoAndroid;
                this.link = this.ThermoAndroid;
                break;
            }
            case 'ThermoGSM': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'ThermoGSM' } }));
                window.location.href = this.ThermoGSMAndroid;
                this.link = this.ThermoGSMAndroid;
                break;
            }
            case 'ThermoWIFI': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'ThermoWIFI' } }));
                window.location.href = this.ThermoWIFIAndroid;
                this.link = this.ThermoWIFIAndroid;
                break;
            }
            case 'CameAccess': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'CameAccess' } }));
                window.location.href = this.CameAccessAndroid;
                this.link = this.CameAccessAndroid;
                break;
            }
            case 'SetupPro': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'SetupPro' } }));
                window.location.href = this.SetupProAndroid;
                this.link = this.SetupProAndroid;
                break;
            }
            case 'UpdateToSetupPro': {
                this.redirectUpdateToSetupPro();
                break;
            }
            default: {
                this.link = 'ErrAndroid--' + this.browserDevice;
                break;
            }
        }
    }

    redirectApple(): void {
        switch (this.appId) {
            case 'Setup': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'Setup' } }));
                window.location.href = this.SetupApple;
                this.link = this.SetupApple;
                break;
            }
            case 'Automation': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'Automation' } }));
                window.location.href = this.AutomationApple;
                this.link = this.AutomationApple;
                break;
            }
            case 'AutomationBT': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'AutomationBT' } }));
                window.location.href = this.AutomationBTApple;
                this.link = this.AutomationBTApple;
                break;
            }
            case 'Thermo': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'Thermo' } }));
                window.location.href = this.ThermoApple;
                this.link = this.ThermoApple;
                break;
            }
            case 'ThermoGSM': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'ThermoGSM' } }));
                window.location.href = this.ThermoGSMApple;
                this.link = this.ThermoGSMApple;
                break;
            }
            case 'ThermoWIFI': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'ThermoWIFI' } }));
                window.location.href = this.ThermoWIFIApple;
                this.link = this.ThermoWIFIApple;
                break;
            }
            case 'CameAccess': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'CameAccess' } }));
                window.location.href = this.CameAccessApple;
                this.link = this.CameAccessApple;
                break;
            }
            case 'SetupPro': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'SetupPro' } }));
                window.location.href = this.SetupProApple;
                this.link = this.SetupProApple;
                break;
            }
            case 'UpdateToSetupPro': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'ios', appMobile: 'SetupPro' } }));
                window.location.href = this.SetupProApple;
                this.link = this.SetupProApple;
                break;
            }
            default: {
                this.link = 'ErrIos--' + this.browserDevice;
                break;
            }
        }
    }


    redirectUpdateToSetupPro(): void {
        switch (this.lang) {
            case 'it-IT': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidIt;
                this.link = this.UpdateSetupProAndroidIt;
                break;
            }
            case 'en-US': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidEn;
                this.link = this.UpdateSetupProAndroidEn;
                break;
            }
            case 'fr-FR': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidFr;
                this.link = this.UpdateSetupProAndroidFr;
                break;
            }
            case 'de-DE': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidDe;
                this.link = this.UpdateSetupProAndroidDe;
                break;
            }
            case 'nl-NL': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidNl;
                this.link = this.UpdateSetupProAndroidNl;
                break;
            }
            case 'ru-RU': {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidRu;
                this.link = this.UpdateSetupProAndroidRu;
                break;
            }
            default: {
                this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'qrcode_redirect', params: { appOs: 'android', appMobile: 'UpdateToSetupPro' } }));
                window.location.href = this.UpdateSetupProAndroidEn;
                this.link = this.UpdateSetupProAndroidEn;
                break;
            }
        }
    }
}
